import React from 'react';

import { Grid, Typography } from '@mui/material';
import Image from 'next/image';

interface SubsectionProps {
  imgUrl: string;
  title: string;
  description: string;
}

const Subsection: React.FC<SubsectionProps> = ({
  imgUrl,
  title,
  description,
}) => {
  return (
    <Grid
      container
      sx={{
        flexDirection: 'column',
        textAlign: 'center',
        maxWidth: '21.25rem',
        margin: 'auto',
      }}
      spacing={1}
    >
      <Grid>
        <Image
          style={{
            borderRadius: '50%',
          }}
          src={imgUrl}
          alt="programs"
          //@todo-upgrade: make sure this is the right size
          height="160"
          width="160"
        />
      </Grid>
      <Grid>
        <Typography variant="h6">{title}</Typography>
      </Grid>
      <Grid>
        <Typography variant="body1">{description}</Typography>
      </Grid>
    </Grid>
  );
};

// We may get requirement to make these program / tenant specific down the line but images are static across all programs for now.
const gridItems: SubsectionProps[] = [
  {
    imgUrl:
      'https://territory-assets.s3.amazonaws.com/images/programs/program-default-img-1.png',
    title: 'What’s included in your order',
    description:
      'Each box contains a curated selection of meals for lunch and dinner that fulfill the dietary standards of the program.',
  },
  {
    imgUrl:
      'https://territory-assets.s3.amazonaws.com/images/programs/program-default-img-2.png',
    title: 'Delivered to your door',
    description:
      'Every delivery is insulated and surrounded by ice so your meals stay fresh until they’re unpacked.',
  },
  {
    imgUrl:
      'https://territory-assets.s3.amazonaws.com/images/programs/program-default-img-3.png',
    title: 'Fresh and ready to eat',
    description:
      'All meals are dietitian designed, chef prepared, and ready for consumption after 90-120 seconds in the microwave.',
  },
];

const WhatToExpect: React.FC = () => {
  return (
    <Grid
      container
      spacing={6}
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Grid>
        <Typography variant="h4">What to expect</Typography>
      </Grid>
      <Grid
        sx={{
          width: '100%',
        }}
      >
        <Grid
          container
          direction="row"
          spacing={4}
          sx={{
            justifyContent: 'space-between',
          }}
        >
          {gridItems.map((gridItem) => {
            return (
              <Grid
                key={gridItem.title}
                size={{
                  xs: 12,
                  sm: 12,
                  md: 4,
                }}
              >
                <Subsection
                  key={gridItem.title}
                  imgUrl={gridItem.imgUrl}
                  title={gridItem.title}
                  description={gridItem.description}
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WhatToExpect;
